'use client';

import { useState, useEffect } from 'react';

/* ───────────── BGV — background verification clears at the source ───────────── */

interface CheckItem {
  k: string;
  src: string;
  v: string;
}

export function BGVExp() {
  const [step, setStep] = useState<number>(0);

  const CHECKS: CheckItem[] = [
    { k: 'Identity & right to work', src: 'Gov ID · biometric', v: 'Verified' },
    { k: 'Employment history', src: '3 employers · direct', v: 'Confirmed' },
    { k: 'Education', src: 'Degree · registrar', v: 'Verified' },
    { k: 'Global watchlist', src: 'Sanctions · PEP', v: 'Clear' },
    { k: 'Criminal record', src: 'Multi-jurisdiction', v: 'Clear' },
    { k: 'References', src: '2 of 2 · signed', v: 'Confirmed' },
  ];

  useEffect(() => {
    const t = CHECKS.map((_, i) =>
      setTimeout(() => setStep(i + 1), 450 + i * 480)
    );
    return () => t.forEach(clearTimeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const done = step >= CHECKS.length;
  const pct = Math.round((Math.min(step, CHECKS.length) / CHECKS.length) * 100);

  return (
    <div style={{ height: '100%', background: 'var(--surface)', borderRadius: 'var(--r-md)', border: '1px solid var(--border)', padding: '16px 18px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: '30px', height: '30px', borderRadius: '9px', background: 'var(--green-soft)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '11px', color: 'var(--green)' }}>PS</div>
          <div>
            <div style={{ fontSize: '13px', fontWeight: 600 }}>Background check</div>
            <span className="mono" style={{ fontSize: '9px', color: 'var(--text-3)' }}>Sr. Backend · PS-4471</span>
          </div>
        </div>
        <span className="mono" style={{ fontSize: '9px', color: done ? 'var(--green)' : 'var(--text-3)', transition: 'color .4s' }}>{done ? '● CLEARED' : `verifying ${pct}%`}</span>
      </div>

      {/* progress */}
      <div style={{ height: '3px', borderRadius: '2px', background: 'var(--surface-raised)', overflow: 'hidden', marginBottom: '14px' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: 'var(--green)', transition: 'width .5s var(--ease)' }}></div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '7px', flex: 1 }}>
        {CHECKS.map((c, i) => {
          const ok = step > i;
          return (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '11px', padding: '9px 12px', borderRadius: 'var(--r-sm)',
              background: ok ? 'var(--green-soft)' : 'var(--surface)', border: `1px solid ${ok ? 'color-mix(in srgb, var(--green) 22%, transparent)' : 'var(--border)'}`,
              transition: 'background .5s var(--ease), border-color .5s var(--ease)' }}>
              <span style={{ width: '18px', height: '18px', borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: ok ? 'var(--green)' : 'transparent', border: ok ? 'none' : '1.5px solid var(--text-4)', transition: 'all .4s var(--ease)' }}>
                {ok && <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#04130d" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"/></svg>}
              </span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '12.5px', fontWeight: 500, color: 'var(--text)' }}>{c.k}</div>
                <div className="mono" style={{ fontSize: '9px', color: 'var(--text-3)' }}>{c.src}</div>
              </div>
              <span className="mono" style={{ fontSize: '10px', fontWeight: 600, color: ok ? 'var(--green)' : 'var(--text-4)', transition: 'color .4s' }}>{ok ? c.v : 'checking'}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
